"use strict";
/*
 * FOR NEMO
 * In NEMO, the layer templates include unneeded resources such as NEMO-HEADER
 * and NEMO-FOOTER as well as CSR Integrator. For the use inside one-layer
 * it is required to only get the content without all other resources. This can be accomplished
 * by loading the 'headless' variant of a template
 * */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setHeadlessUrl = setHeadlessUrl;
function setHeadlessUrl(url) {
    const isHeadlessLink = url.includes('.headless.');
    const hasHtmlReference = url.includes('.html');
    const htmlIsSuffix = url.charAt(url.length - 1) === 'l';
    return hasHtmlReference && htmlIsSuffix && !isHeadlessLink
        ? url.replace('.html', '.headless.html')
        : url;
}
//# sourceMappingURL=setHeadlessUrl.js.map